import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, HashRouter } from "react-router-dom";
import App from "./App";

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const Router = process.env.NODE_ENV === "production" ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById("root")).render(
  <Router>
    <App />
  </Router>
);

//  ENABLE OFFLINE APP SHELL
serviceWorkerRegistration.register();
